import { BsFillEaselFill } from 'react-icons/bs';
import { ImUserTie } from 'react-icons/im';
import { MdCoPresent, MdDriveFolderUpload } from 'react-icons/md';
import { RiCommunityFill } from 'react-icons/ri';

const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause5ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/employee_list?filter=createdAt',
    isLink: true,
    p: 'MASTER LIST OF',
    span: 'EMPLOYEE',
    isIcon: true,
    icon: <ImUserTie size="5rem" color="#135089" />,
  },
  {
    sNo: 2,
    link: '/common/department_list?filter=createdAt',
    isLink: true,
    p: 'MASTER LIST OF',
    span: 'DEPARTMENT',
    isIcon: true,
    icon: <RiCommunityFill size="5rem" color="#0f1012" />,
  },
  {
    sNo: 3,
    link: '/common/masterlistoffaculty?filter=createdAt',
    isLink: true,
    clauseNo: 5,
    p: 'Master List Of',
    span: 'FACULTY',
    isIcon: true,
    icon: <ImUserTie size="5rem" color="#135089" />,
  },
  {
    sNo: 4,
    link: '/common/trainingTniHome',
    isLink: true,
    p: 'TRAINING',
    clauseNo: 5,
    span: '',
    isIcon: true,
    icon: <BsFillEaselFill size="5rem" color="#135089" />,
  },
  {
    sNo: 6,
    link: '/common/skillEvaluationHome',
    isLink: true,
    p: 'Skill',
    span: 'Evaluation',
    clauseNo: 5,
    isIcon: true,
    icon: <BsFillEaselFill size="5rem" color="#135089" />,
  },
];
export default tiles;
